/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { callbackService } from "publicApis/controller/callbackService";
import { GET_FEATURE_FLAG } from "../constants/constants";

const hasCallbackRegisteredPromisesMap = {};
const hasCallbackRegisteredPromisesResolveMap = {};
hasCallbackRegisteredPromisesMap[GET_FEATURE_FLAG] = {
  promise: new Promise(resolve => {
    hasCallbackRegisteredPromisesResolveMap[GET_FEATURE_FLAG] = { resolve };
  })
};

export const getFeatureFlagApis = () => {
  function registerPreviewCallback(eventName, callbackFn) {
    if (typeof callbackFn === "function") {
      callbackService.registerCallback(eventName, callbackFn);
      if (hasCallbackRegisteredPromisesMap[eventName]) {
        hasCallbackRegisteredPromisesResolveMap[eventName].resolve();
      }
    }
  }

  function getFeatureFlag(flag) {
    return hasCallbackRegisteredPromise(GET_FEATURE_FLAG).then(() =>
      callbackService.getCallback(GET_FEATURE_FLAG)(flag)
    );
  }

  function hasCallbackRegisteredPromise(eventName) {
    return hasCallbackRegisteredPromisesMap[eventName].promise;
  }

  return {
    registerPreviewCallback,
    getFeatureFlag
  };
};
